import { render, staticRenderFns } from "./deliverOrdersData.vue?vue&type=template&id=d59842e4&scoped=true&"
import script from "./deliverOrdersData.vue?vue&type=script&lang=js&"
export * from "./deliverOrdersData.vue?vue&type=script&lang=js&"
import style0 from "./deliverOrdersData.vue?vue&type=style&index=0&id=d59842e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59842e4",
  null
  
)

component.options.__file = "deliverOrdersData.vue"
export default component.exports